import * as React from 'react'

export const vacancySearch = () => {
  return (
    <section className="search-vacancies sv">
      <div className='sv__inner container container--m grid--block'>
        <form className='sv__form'>
          <input 
            type="search"
            placeholder="Search for jobs"
            className='sv__input text--l'
          />
          <div className="sv__actions">
            <button className='button button--filter'>
              <span>Filter</span>
              <svg aria-hidden="true" width={32} height={30}><use xlinkHref="#icon--filter" /></svg>
            </button>
            <button className='button button--primary'>Submit</button>
          </div>
        </form>
      </div>
    </section>
  )
}
